import { pipeAny } from '../../../shared/misc';

const checksPassThroughUrl = (config) => ({ url }) => new RegExp(config.passThroughUrl, 'i').test(url);

// this pause rendering page till user is logged in:
const checksWaitTillLoggedIn = (config) => ({ isLoggedIn }) => (config.waitTillLoggedIn ? isLoggedIn === false : false);

export const checkPassThrough = (config) => pipeAny(
  checksPassThroughUrl(config),
);

export const checkBlock = (config) => pipeAny(
  checksWaitTillLoggedIn(config)
);
